/* eslint-disable default-case */
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { listMeGyms, changeGym } from './actions';

const initialState = {
  error: null,
  items: [],
  loading: false,
  item: null,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case changeGym.TRIGGER:
    case listMeGyms.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case listMeGyms.SUCCESS:
      draft.items = payload;
      break;
    case changeGym.SUCCESS:
      draft.item = payload;
      break;
    case changeGym.FAILURE:
    case listMeGyms.FAILURE:
      draft.error = payload;
      break;
    case changeGym.FULFILL:
    case listMeGyms.FULFILL:
      draft.loading = false;
      break;
  }
}, initialState);

export default reducer;
